import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ModalCadastrarPerfilComponent } from '../../../components/modal-cadastrar-perfil/modal-cadastrar-perfil.component';
import { ModalEditarPerfilComponent } from '../../../components/modal-editar-perfil/modal-editar-perfil.component';
import { AuthenticationService, PerfilService } from 'src/app/services';
import { IPerfil, IPutPerfilBody } from 'src/app/interfaces';
import { ListaPaginada } from 'src/app/models';
import { MatSidenav } from '@angular/material/sidenav';
import { Perfil } from 'src/app/models/perfil';
import { IToken } from 'src/app/interfaces/token/IToken';
import { IAutorizacoes } from 'src/app/interfaces/token/IAutorizacoes';
import { ModalExcluirPerfilComponent } from 'src/app/components/modal-excluir-perfil/modal-excluir-perfil.component';
import { SidebarPermissoesComponent } from 'src/app/components/sidebar-permissoes/sidebar-permissoes.component';

@Component({
  selector: 'app-listar-perfil-acesso',
  templateUrl: './listar-perfil-acesso.component.html',
  styleUrls: ['./listar-perfil-acesso.component.scss']
})
export class ListarPerfilAcessoComponent implements OnInit, OnDestroy {
  @ViewChild(ModalCadastrarPerfilComponent)
  modalCadastrarPerfil: ModalCadastrarPerfilComponent;

  @ViewChild(ModalEditarPerfilComponent)
  modalEditarPerfil: ModalEditarPerfilComponent;

  @ViewChild(ModalExcluirPerfilComponent)
  modalExcluirPerfil: ModalExcluirPerfilComponent;

  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;

  @ViewChild(SidebarPermissoesComponent)
  sidebarPermissoes: SidebarPermissoesComponent;

  filtraForm: FormGroup;
  subscriptions$ = new Subscription();
  perfis = new ListaPaginada<IPerfil>();
  perfilSelecionado = new Perfil();
  permissoes: IToken;
  autorizacoes: IAutorizacoes;
  autorizacoesPerfilCadastrado: IAutorizacoes;
  putPerfilBody: IPutPerfilBody;
  token: IToken = this.authenticationService.obterToken();

  constructor(
    private fb: FormBuilder,
    private perfilService: PerfilService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.filtraForm = this.fb.group({
      nome: ['']
    });

    this.filtraForm
      .get('nome')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => this.getPerfis());

    this.getPerfis();
    this.gerenciarPermissoesTela();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authenticationService.obterToken().autorizacoes;
  }

  abrirSidebar(perfil: IPerfil) {
    this.perfilSelecionado = perfil;

    this.autorizacoesPerfilCadastrado = {
      gerarTokenEquipamento: perfil.gerarTokenEquipamento,
      listarDemonstrativosFinanceiros: perfil.listarDemonstrativosFinanceiros,
      exibirDetalhesDemonstrativoFinanceiro:
        perfil.exibirDetalhesDemonstrativoFinanceiro,
      realizarDownloadFechamento: perfil.realizarDownloadFechamento,
      listarBoletos: perfil.listarBoletos,
      realizarDownloadBoleto: perfil.realizarDownloadBoleto,
      listarEquipamentos: perfil.listarEquipamentos,
      realizarDownloadListagemEquipamentos:
        perfil.realizarDownloadListagemEquipamentos,
      editarEquipamento: perfil.editarEquipamento,
      abrirChamadoEquipamento: perfil.abrirChamadoEquipamento,
      visualizarChamadosEquipamento: perfil.visualizarChamadosEquipamento,
      listarChamadosAndamento: perfil.listarChamadosAndamento,
      listarChamadosFinalizados: perfil.listarChamadosFinalizados,
      exibirDetalhesChamado: perfil.exibirDetalhesChamado,
      abrirChamadoSuprimentos: perfil.abrirChamadoSuprimentos,
      listarHistoricosPedidos: perfil.listarHistoricosPedidos,
      exibirDetalhesPedido: perfil.exibirDetalhesPedido,
      listarInventarios: perfil.listarInventarios,
      exibirDetalhesInventario: perfil.exibirDetalhesInventario,
      alterarPosseInventario: perfil.alterarPosseInventario,
      realizarDownloadListagemInventario:
        perfil.realizarDownloadListagemInventario,
      listarContratos: perfil.listarContratos,
      exibirDetalhesContrato: perfil.exibirDetalhesContrato,
      realizarDownloadListagemContrato: perfil.realizarDownloadListagemContrato,
      realizarDownloadEquipamentosContrato:
        perfil.realizarDownloadEquipamentosContrato,
      listarUsuarios: perfil.listarUsuarios,
      listarPerfis: perfil.listarPerfis,
      controlarUsuarios: perfil.controlarUsuarios,
      controlarPerfis: perfil.controlarPerfis,
      gerenciarPermissoes: perfil.gerenciarPermissoes,
      visualizarDashboard: perfil.visualizarDashboard
    };

    this.putPerfilBody = {
      ...this.autorizacoesPerfilCadastrado,
      perfilInterno: perfil.perfilInterno,
      codigo: perfil.codigo
    };

    document.body.classList.add('overflow-hidden');
    this.sidenav.open();
  }

  aoFecharSidebar() {
    this.sidebarPermissoes.recolherPaineis();
    this.reiniciarPermissoes();
    document.body.classList.remove('overflow-hidden');
  }

  fecharSidebar() {
    this.sidenav.close();
  }

  reiniciarPermissoes() {
    this.perfilSelecionado = new Perfil();
  }

  getPerfis(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.perfis.paginaAtual = 1;
    }

    this.subscriptions$.add(
      this.perfilService
        .getPerfil({
          Pesquisar: this.filtraForm.get('nome')?.value,
          idUsuario: this.token?.id,
          itensPorPagina: this.perfis.itensPorPagina,
          paginaAtual: this.perfis.paginaAtual
        })
        .subscribe({
          next: ({ data }) => {
            this.perfis = data;
          }
        })
    );
  }

  cadastrarPerfil() {
    this.modalCadastrarPerfil.abrirModal();
  }

  editarPerfil(perfil: IPerfil) {
    this.modalEditarPerfil.abrirModal(perfil);
  }

  excluirPerfil(perfil: IPerfil) {
    this.modalExcluirPerfil.openModal(perfil);
  }
}
